import { SignalingMessageOffer } from "../../../services";
import { BaseStreamingCommand } from "./BaseStreamingCommand";

export class OfferCommand extends BaseStreamingCommand {
  public execute(e: unknown): void {
    const event = e as CustomEvent<SignalingMessageOffer>;
    const offer = event.detail;
    if (!this.checkRoomId(offer.data.room)) return;
    if (!offer.from) return;
    const peer = this.getPeer(offer.from);
    if (!peer) return;
    let description: RTCSessionDescription;
    try {
      description = new RTCSessionDescription({
        sdp: offer.data.sdp,
        type: "offer"
      });
    } catch (error) {
      console.warn("Failed to build offer description", error);
      return;
    }
    peer
      .handleDescription(description, this.getRoomLocalParticipantRemoteId())
      .catch((error: unknown) => {
        console.warn("Failed to apply offer description", error);
      });
  }
}
